import React from 'react';
import propTypes from './propTypes';

const DaylyWork = ({ className = 'icon', notUseClass = false, style = {} }) => (
  <svg
    className={notUseClass ? '' : className}
    style={{ color: '#696f88', ...style }}
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <circle cx="5.5" cy="16.5" r="1.5" fill="currentColor" />
    <path d="M7.5 2H4C2.34315 2 1 3.34315 1 5V22C1 22.5523 1.44772 23 2 23H4C4.55228 23 5 22.5523 5 22V21H13V22C13 22.5523 13.4477 23 14 23H16C16.5523 23 17 22.5523 17 22V17.5H15V18C15 18.5523 14.5523 19 14 19H4C3.44772 19 3 18.5523 3 18V14H7.5V12H3V10.6667L5 8H7.5V6H4.5C4.18524 6 3.88885 6.14819 3.7 6.4L3 7.33333V5C3 4.44772 3.44772 4 4 4L7.5 4V2Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M21 4H11L11 14H21V4ZM11 2C9.89543 2 9 2.89543 9 4V14C9 15.1046 9.89543 16 11 16H21C22.1046 16 23 15.1046 23 14V4C23 2.89543 22.1046 2 21 2H11Z" fill="currentColor" />
    <rect x="12" y="9" width="3" height="3" fill="currentColor" />
    <rect x="10" y="6" width="12" height="2" fill="currentColor" />
    <path d="M11.0853 17C11.2912 17.5826 11.8469 18 12.5 18C13.1531 18 13.7087 17.5826 13.9146 17H11.0853Z" fill="currentColor" />
  </svg>
);

DaylyWork.propTypes = propTypes;

export default DaylyWork;
